import { Card } from "@/components/ui/card";
import { Shimmer, StatCardShimmer } from "@/components/ui/shimmer";

interface StatCardProps {
  title: string;
  value: string;
  subtitle?: string;
  icon: React.ReactNode;
  loading?: boolean;
  valueColor?: string;
}

export default function StatCard({ title, value, subtitle, icon, loading, valueColor }: StatCardProps) {
  return (
    <Shimmer
      loading={!!loading}
      fallback={<StatCardShimmer />}
    >
      <Card className="h-full">
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <span className="text-[13px] font-medium text-muted-foreground uppercase tracking-wider">
              {title}
            </span>
            <div className="w-9 h-9 rounded-lg flex items-center justify-center bg-primary/5 text-foreground">
              {icon}
            </div>
          </div>

          <h4
            className="text-[28px] font-bold tracking-tight leading-none"
            style={valueColor ? { color: valueColor } : undefined}
          >
            {value}
          </h4>

          {subtitle && (
            <p className="text-[13px] text-muted-foreground mt-2">{subtitle}</p>
          )}
        </div>
      </Card>
    </Shimmer>
  );
}
